import React, { useState } from "react";

const ReportsNavbar = ({ setTableFor }) => {
  const [activeButton, setActiveButton] = useState("");

  const handleButtonClick = (table) => {
    setTableFor(table);
    setActiveButton(table);
  };

  return (
    <div className="navWrapper flex flex-col items-center border-b ">
      <h1 className="text-xl font-bold text-center ">AI-Enabled Reporting</h1>

      <div className="buttons flex items-start w-full relative mb-2 pl-4">
        <h1 className="absolute -top-4 ml-2 bg-white px-2 font-semibold">
          Locations
        </h1>
        <div className=" flex justify-evenly items-center border-b  border w-max p-2 rounded-md gap-4 overflow-y-auto">
          <button
            type="button"
            className={`focus:outline-none text-white ${
              activeButton === "Lot8"
                ? "bg-blue-500"
                : "bg-yellow-400 hover:bg-yellow-500"
            }    font-medium rounded-lg text-sm dark:focus:ring-yellow-900 py-2 px-4`}
            onClick={() => handleButtonClick("Lot8")}
          >
            Lot8
          </button>

          <button
            type="button"
            className={`focus:outline-none text-white ${
              activeButton === "Kachuberia"
                ? "bg-blue-500"
                : "bg-yellow-400 hover:bg-yellow-500"
            }    font-medium rounded-lg text-sm dark:focus:ring-yellow-900 py-2 px-4`}
            onClick={() => handleButtonClick("Kachuberia")}
          >
            Kachuberia
          </button>

          <button
            type="button"
            className={`focus:outline-none text-white ${
              activeButton === "Babu-Ghat"
                ? "bg-blue-500"
                : "bg-yellow-400 hover:bg-yellow-500"
            }    font-medium rounded-lg text-sm dark:focus:ring-yellow-900 py-2 px-4`}
            onClick={() => handleButtonClick("Babu-Ghat")}
          >
            Babu Ghat
          </button>

          <button
            type="button"
            className={`focus:outline-none text-white ${
              activeButton === "Benubon"
                ? "bg-blue-500"
                : "bg-yellow-400 hover:bg-yellow-500"
            }    font-medium rounded-lg text-sm dark:focus:ring-yellow-900 py-2 px-4`}
            onClick={() => handleButtonClick("Benubon")}
          >
            Benubon
          </button> 
          <button
            type="button"
            className={`focus:outline-none text-white ${
              activeButton === "Chemaguri"
                ? "bg-blue-500"
                : "bg-yellow-400 hover:bg-yellow-500"
            }    font-medium rounded-lg text-sm dark:focus:ring-yellow-900 py-2 px-4`}
            onClick={() => handleButtonClick("Chemaguri")}
          >
            Chemaguri
          </button>

          <button
            type="button"
            className={`focus:outline-none text-white ${
              activeButton === "Namkhana"
                ? "bg-blue-500"
                : "bg-yellow-400 hover:bg-yellow-500"
            }    font-medium rounded-lg text-sm dark:focus:ring-yellow-900 py-2 px-4`}
            onClick={() => handleButtonClick("Namkhana")}
          >
            Namkhana
          </button>

          <button
            type="button"
            className={`focus:outline-none text-white ${
              activeButton === "Sagar-Bus-Stand"
                ? "bg-blue-500"
                : "bg-yellow-400 hover:bg-yellow-500"
            }    font-medium rounded-lg text-sm dark:focus:ring-yellow-900 py-2 px-4`}
            onClick={() => handleButtonClick("Sagar-Bus-Stand")}
          >
            Sagar Bus Stand
          </button>

          <button
            type="button"
            className={`focus:outline-none text-white ${
              activeButton === "Sagar-Beach-Temple"
                ? "bg-blue-500"
                : "bg-yellow-400 hover:bg-yellow-500"
            }    font-medium rounded-lg text-sm dark:focus:ring-yellow-900 py-2 px-4`}
            onClick={() => handleButtonClick("Sagar-Beach-Temple")}
          >
            Sagar Beach Temple
          </button>

          <button
            type="button"
            className={`focus:outline-none text-white ${
              activeButton === "Test3"
                ? "bg-blue-500"
                : "bg-yellow-400 hover:bg-yellow-500"
            }    font-medium rounded-lg text-sm dark:focus:ring-yellow-900 py-2 px-4`}
            onClick={() => handleButtonClick("Test3")}
          >
            Test3
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReportsNavbar;
